<template>
  <div class="bulk-import">
    <!-- 头部 -->
    <div class="bulk-import-head">
      <div class="bulk-import-head-left">
        <el-button v-if="isPage" type="primary" link style="color: #333;" @click="goBack">
          <i class="iconfont icon-fanhui1"></i>
          返回
        </el-button>
        <span style="color: #FF0000;">*特别提醒：{{ tipText[importModeValue] }}(建议一次性最多导入500条数据)</span>
      </div>
      <div class="bulk-import-head-right">
        <el-button size="small" type="primary" round @click="toBigData">大数据导入</el-button>
        <el-button @click="openExcelImport" size="small" type="primary" round>从excel导入</el-button>
        <el-button @click="submitImport" size="small" type="primary" round>提交</el-button>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="bulk-import-table" id="import-sheet">
    
    </div>
    <!-- 底部 -->
    <div v-show="!isBtnCustom" class="bulk-import-footer">
      <div class="bulk-import-footer-left">
        <span class="option-title">导入方式</span>
        <el-select v-model="importModeValue" style="width: 180px;" size="small">
          <template v-for="(item, index) in importModeOptions">
            <el-option v-if="item.isChecked"  :value="item.value" :label="item.text" :key="index"></el-option>
          </template>
        </el-select>
        <template v-if="importModeValue">
          <span class="option-title">查询字段</span>
          <el-select v-model="valueKey" @change="valueKeyChange" style="width: 180px;" size="small">
            <el-option
              v-for="item in optionKeyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span class="option-title">字段选择</span>
          <el-input
            style="width: 100px;"
            v-if="valueKey === 0"
            v-model="inputKey"
            size="small"
            :disabled="true">
          </el-input>
          <el-select 
            v-else 
            @change="valueSearchListChange"
            style="width: 180px;"
            size="small"
            v-model="valueSearchList" 
            collapse-tags 
            multiple 
            :multiple-limit="5"
            placeholder="请选择字段（最多5个）">
            <el-option
              v-for="item in optionSearchList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <span class="notice" v-if="isShowNotice">
          {{ noticeText }}
          <el-switch v-model="isNotice" :active-value="1" :inactive-value="0" size="small" ></el-switch>
        </span>
      </div>
      <div class="bulk-import-footer-right" v-if="isCountField">
        <span v-for="(item, index) in countFieldShow" :key="index" :class="countFieldShow.length - 1 !== index ? 'field-line' : ''">
          {{ item.tips }}：{{ item.value || 0 }} 
        </span>
      </div>
    </div>
    <!-- 进入页面的加载动画 -->
    <div v-show="isPageLoading" class="mask-box">
      <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/download.gif" alt="">
      <span class="mask-box-text">数据加载中请稍后</span>
    </div>
    <!-- 导入数据源 -->
    <pop-up
      v-model:isView="isViewExcel"
      width="720px"
      title="从Excel导入"
      submitBtnText="开始导入"
      @submit="importExcel"
    >
      <template #body>
        <div class="excel-import">
          <div>
            请选择要导入的数据文件
            <span style="color: #999;">（注：文件为excel格式）</span>
          </div>
          <div class="upload-content">
            <div class="upload-content-left">
              <div class="download-btn-title"> 1.下载导入模板</div>
              <div class="download-btn" @click="downloadTemp">
                <i class="iconfont icon-xiazai2x"></i>
                <span>下载模板</span>
              </div>
            </div>
            <div class="upload-content-right">
              <div class="download-btn-title">2.上传完善好的内容，支持上传文件为：excel</div>
              <el-upload
                :action="uploadUrl"
                accept=".xlsx, .xls, .csv"
                :show-file-list="false"
                :on-success="handleSuccess"
              >
                <div class="download-btn">
                  <template v-if="uplaodTemplate">
                    <div class="top">
                      <i class="iconfont icon-xuanzhong"></i>
                    </div>
                    <div class="bottom">
                      <span>
                        <i class="iconfont icon-EXCEL"></i>
                        <span>{{ getFileName(uplaodTemplate) }}</span>
                      </span>
                      <span>上传完成</span>
                    </div>
                  </template>
                  <template v-else>
                    <i class="iconfont icon-EXCEL"></i>
                    <span>上传文件</span>
                  </template>
                </div>
              </el-upload>
            </div>
          </div>
          <!-- 导入说明部分 -->
          <div class="excel-import-tips">
            <h4 class="excel-import-tips-title">数据导入说明：</h4>
            <richTextView :html="importTips" />
          </div>
        </div>
      </template>
    </pop-up>
    <!-- 导入数据 -->
    <pop-up
      v-model:isView="isViewImport"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :closeBtn="false"
      width="720px"
      title="提交校验"
      :submitBtnText="submitBtnText"
      @submit="importData"
    >
      <template #body>
        <div class="import-verify" v-loading="isLoading">
          <p class="succes-tips">成功导入{{ successNum }}条数据</p>
          <p class="error-tips">{{ errorNum }}条数据填写错误</p>
          <div class="edit-tips" v-if="errorFileUrl">
            <p>1）下载错误模板，根据报告修正错误 
              <el-button type="primary" link @click="downloadErrorTemp">下载错误模板</el-button>
              <el-button type="primary" link @click="editErrorTemp">在线修改模板</el-button> 
            </p>
            <p>2）将错误内容重新上传 
              <el-upload
                :action="uploadUrl"
                accept=".xlsx,.xls,.csv"
                :show-file-list="false"
                :on-success="againHandleSuccess"
              >
                <el-button type="primary" link>重新上传</el-button> 
              </el-upload>
            </p>
          </div>
        </div>
      </template>
    </pop-up>
    <fileUploadDia ref="fileUploadDiaRef" @confirm="fileUploadConfirm" @close="fileUploadClose" />
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import options from './util/util.import.js'
import { exportSheetExcel, submitVerify } from './util/exportExcel.js';
import importExcelMixin from './util/importExcelMixin.js';
import linkMixin from './util/linkMixin.js';
import { axiosBase } from "@/api/api";
import { openapiGetapproval } from '@/port/clientSide/applicationRouting'
import { dealText } from '@/api/common.js'
import { filePreview, onTimeDifference } from '@/api/global.js';
import { apiImportapproval, updateapprovingbatch } from '@/port/clientSide/workbench'
import { apiGetreportdatalist } from '@/port/clientSide/formFillinPageChild/newRelRadio.js'
import { cloneDeep } from 'lodash';
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins'
import { importData } from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/utils.js'
import { getopenuserlist, getopenrolelist, getopenorganizationlist } from '@/port/clientSide/multipleChoice.js'
import {
  getlinkeddatalist
} from "@/port/clientSide/oaExamineAudit";
import { showMyDialog } from "@/components/clientSide/workbench/bulkImportCpn/uploadDialog.js";
import { stringToArrayBufferUpLoad } from '@/api/utils'

const luckysheet = window.luckysheet // 表格实例
export default {
  name: 'TMbulkImport',
  data () {
    return {
      // 表格配置
      options: { 
        hook: {
          cellMousedownBefore: this.cellMousedownBefore,
          cellEditBefore: this.cellEditBefore,
          cellUpdated: this.cellUpdated,
          cellUpdateBefore: this.cellUpdateBefore,
          rangePasteBefore: this.rangePasteBefore,
          rangePasteAfter: this.rangePasteAfter,
          workbookCreateAfter: this.workbookCreateAfter,
        }, ...options 
      },
      importModeValue: 0,
      valueKey: 0, //查询字段
      optionKeyList: [
        {
          value: 0,
          label: '数据ID覆盖'
        },
        {
          value: 1,
          label: '字段覆盖'
        }
      ],
      inputKey: '单号',
      valueSearchList: [], // 查询字段选中的值
      optionSearchList: [], // 查询字段列表
      isNotice: 0,
      isCountField: false,
      countField: {},
      isShowNotice: true,
      noticeText: '通知关联人员',
      importModeOptions: [
        { isChecked: true, value: 0, label: '新增数据', text: '新增数据'}, 
        { isChecked: true, value: 1, label: '更新数据', text: '更新数据'}, 
        { isChecked: true, value: 2, label: '新增和更新数据', text: '新增和更新数据'}
      ],
      isViewExcel: false, // ecxel导入的弹窗
      isViewImport: false, // 数据验证的弹窗
      approvalId: 0,
      appName: '',
      customData: [],
      functionParms: [],
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      // eslint-disable-next-line no-useless-escape
      importTips: '<p style=\"line-height: 1;\">1.请使用.xls和xlsx格式的文件导入，导入的字段必须按模板的字段导入； </p><p style=\"line-height: 1;\">2.*号为必填字段，非必填的字段可空白；</p><p style=\"line-height: 1;\">3.关联表单、关联多选控件关联子表时，系统将按上传的excel中该子表的数据单号匹配系统中的 数据； </p><p style=\"line-height: 1;\">4.导入的数据，根据设置查询对象将原有数据进行新增、更新、新增和更新； </p><p style=\"line-height: 1;\">5.选择联系人字段时，请选择多字段进行匹配，避免重名用户被覆盖。</p>',
      importTemplate: { value: 0 }, // 下载模板
      property: [], // 应用模板
      colConfg: {}, // 每列的配置
      uplaodTemplate: '',
      importType: 0,  // 0 全部数据 1 个人数据
      isLoading: true,
      isSuccess: false,
      successNum: 0,
      errorNum: 0,
      importCode: 0,
      errorFileUrl: '',
      linkage: {}, // 触发联动的控件
      dataOptionsData: {}, // 选项联动的数据选项
      inputRow: [], // 每条数据之间的间隔行
      isSecond: false, // 是否有二级控件
      isPageLoading: true,  // 页面加载
      isPage: false, // 判断是否是组件打开还是页面打开
      hideCol: [], // 需要隐藏的列
      readonlyCol: [], // 只读的列
      currentEditCell: {}, // 当前编辑的单元格
      fillInData: [], // 传参进来要填入的数据
      defaultInData: {}, // 要填入的默认值
      requiredFieldCol: [], // 必填的一级控件列号
      tipText: {
        0: '新增数据时，系统会将格式正确的数据直接导入，错误数据修正后直接导入。',
        1: '更新数据时，如表格数据为空，将保留原始数据不做更新。(橘色背景的字段为查询条件字段)',
        2: '新增和更新数据时，条件为空或者没有匹配上则直接新增。(橘色背景的字段为查询条件字段)',
      },
      queryConfig: {},
      isInsertData: false,
      isBtnCustom: false, // 是否是按钮自定义导入
      isBtnCustomInit: true, // 是否是按钮自定义导入的初始化
      btnImportType: 'table', // 放入方式是文件打开还是表格打开
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      userSaveData: {},
      orgSaveData: {},
      roleSaveData: {},
      unpivot: {},
      isDrop: false,
      aiTips: '',
      isAiDrop: false,
      importAllData: [],
      pivotHeadLength: 1,
      copyText: ''
    }
  },
  props: {
    customDeskInfo: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    uploadUrl () {
      return this.$url + '/userfile/upload?accesstoken=' + this.token
    },
    submitBtnText () {
      let text = '完成'
      // if (this.importCode === -1) {
      //   text = '重新填写'
      // } else if (this.errorNum !== 0) {
      //   text = '在线修改错误模板'
      // }
      return text
    },
    
    countFieldShow () {
      const res = []
      for(const key in this.countField) {
        const list = this.countField[key]
        list.forEach(item => {
          item.tips = item.name + (item.formula === 'sum' ? '合计' : '平均值')
          res.push(item)
        })
      }
      return res
    },
    // 必填的一级控件
    requiredField () {
      const arr = []
      for(const key in this.colConfg) {
        const item = this.colConfg[key]
        if (!item.ftype && item.required === 'required') {
          arr.push(item)
        }
      }
      return arr
    },
    // 是否根据数据id更新
    isUpdateById() {
      const { isUpdateById, importType, importModeValue } = this.customDeskInfo
      return isUpdateById === 'true' && importType === 'file' && importModeValue === '1'
    },
    importHeaderType () {
      return this.queryConfig.importHeaderType
    },
  },
  watch: {
    // 导入方式
    importModeValue: {
      handler (newVal, oldVal) {
        this.importModeValueChange(newVal, oldVal)
      }
    },
  },
  components: {
    popUp: defineAsyncComponent(() => import('@/components/common/popUp')),
    richTextView: defineAsyncComponent(() => import('@/components/common/richTextView.vue')),
    fileUploadDia: defineAsyncComponent(() => import('./bulkImportCpn/fileUploadDia.vue'))
  },
  mixins: [importExcelMixin, linkMixin, parmsMixins],
  created() {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
    this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
    this.isUpace = true
    }
  },
  methods: {
    // ai文件拖入导入返回
    aiDropConfirm (data) {
      if (Array.isArray(data) && data.length > 0) {
        this.fillInData = data
        if (this.currentExcelFile) {
          this.handleExcelFile(this.currentExcelFile)
        }
      }
    },
    handleDragOver(event) {
      event.dataTransfer.dropEffect = 'copy'; // 设置拖放效果为复制
      if (!this.isDrop) {
        this.isDrop = true
        const that = this
        const uploadDialog = showMyDialog({
          approvalId: that.approvalId,
          aiTips: that.aiTips,
          onConfirm: (data) => {
            that.aiDropConfirm(data)
            uploadDialog.destroy()
            that.isDrop = false
          },
          onCancel: () => {
            uploadDialog.destroy()
            that.isDrop = false
          }
        }, 'aiDropUpload')
      }
    },
    initConfig () {
      this.queryConfig = {}
      if (JSON.stringify(this.customDeskInfo) !== '{}') {
        this.queryConfig = this.customDeskInfo
      } else {
        this.queryConfig = this.$route.query
      }
      const { bulkImportMutat, approvalId, isPage, importType, uplaodTemplate, importModeValue } = this.queryConfig
      this.importType = bulkImportMutat === 'true' ? 0 : 1
      this.approvalId = approvalId
      this.isPage = isPage
      if (importModeValue !== undefined) {
        this.isBtnCustom = true
        this.btnImportType = importType || 'table'
        this.uplaodTemplate = uplaodTemplate || ''
      }
    },
    // 处理自定义的配置
    toSetCustomConfig () {
      const { isNotice, importModeValue, valueKey, valueSearchList } = this.queryConfig
      // 以下是按钮自定义导入的配置信息
      // isNotice 是否告知关联人员
      // importModeValue 导入方式
      if (importModeValue !== undefined) {
        this.importModeValue = Number(importModeValue)
        this.isNotice = isNotice === 'true' ? 1 : 0
        if (this.importModeValue) {
          // 走一遍查询字段改变后的方法
          this.valueKey = Number(valueKey)
          this.valueKeyChange(this.valueKey)
          if (this.valueKey === 1) {
            // 如果是字段覆盖 得去走一遍字段修改后的方法
            this.valueSearchList = JSON.parse(valueSearchList)
            this.valueSearchListChange(this.valueSearchList || [])
          }
        }
      }
    },
    // 查询字段改变
    valueSearchListChange (val) {
      // 根据已选择的字段去修改表头颜色
      for (const key in this.colConfg) {
        const item = this.colConfg[key]
        const color = val.includes(key) ? '#ff9900' : '#fff2cc'
        luckysheet.setCellFormat(0, item.col, 'bg', color)
      }
    },
    // 查询字段类型
    valueKeyChange (val) {
      if (val === 1) {
        this.delNumbers()
      } else if (val === 0) {
        this.valueSearchList = []
        this.valueSearchListChange([])
        this.addNumbers()
      }
    },
    // 文件上传的回调
    fileUploadConfirm (fileList) {
      luckysheet.exitEditMode({ success: () => {
        fileList = fileList.map(item => { return '/userfiles/' + item } )
        luckysheet.setCellValue(this.currentEditCell.row, this.currentEditCell.col, fileList.join(','))
        this.currentEditCell = {}
      }})
    },
    // 文件上传的关闭
    fileUploadClose () {
      luckysheet.exitEditMode()
    },
    // 切换导入方式时对单号的新增减少
    importModeValueChange (newVal, oldVal) {
      if ((newVal === 0) && (oldVal === 1 || oldVal === 2)) {
        // 新增的要去除单号那一列
        this.delNumbers()
      } else if (oldVal === 0 && this.valueKey === 0) {
        // 更新
        this.addNumbers()
      }
    },
    // 新增单号列
    addNumbers () {
      const cell = luckysheet.find('发起人姓名')
      const col = cell.length > 0 ? 1 : 0
      // 如果已经存在单号就不要再添加了
      if (luckysheet.getCellValue(0, col) === '单号') return false
      luckysheet.insertColumn(col, {
        success: () => {
          luckysheet.setCellValue(0, col, '单号')
          luckysheet.setCellFormat(0, col, 'bl', 1)
          luckysheet.setCellFormat(0, col, 'ht', 0)
          luckysheet.setCellFormat(0, col, 'isHead', true)
          luckysheet.setCellFormat(0, col, 'bg', '#ff9900')
          // 如果存在二级控件 那需要合并单元格
          if (this.isSecond) {
            const mc = { 
              r: 0, //主单元格的行号
              c: col, //主单元格的列号
              cs: 1, //合并单元格占的行数
              rs: 2 //合并单元格占的列数
            }
            luckysheet.setCellFormat(0, col, 'mc', mc)
            luckysheet.setCellFormat(1, col, 'mc', { r: 0, c: col })
            const config = luckysheet.getConfig()
            if (config.merge === undefined) config.merge = {}
            config.merge[0 + '_' + col] = mc
            luckysheet.setConfig(config)
          }
          // 单元格配置往后挪一格
          for(const key in this.colConfg) {
            const item = this.colConfg[key]
            if (item.col !== undefined) {
              item.col += 1
            }
          }
          if (this.inputKey === '单号' && this.customDeskInfo.isChooseUpdate === 'true') {
            const startRow = this.isSecond ? 2 : 1
            for (let index = 0; index < this.fillInData.length; index++) {
              const data = this.fillInData[index]
              const val = data['单号_text']
              if (val) {
                luckysheet.setCellValue(startRow + index, col, val)
                luckysheet.setCellFormat(startRow + index, col, 'isReadOnly', true)
              }
            }
          }
          this.requiredFieldCol = this.requiredFieldCol.map(item => { return item + 1 })
        }
      })
    },
    // 去除单号列
    delNumbers () {
      const cell = luckysheet.find('单号')
      if (cell[0]) {
        const col = cell[0].column
        luckysheet.deleteColumn(col, col, {
          success: () => {
            // 单元格配置往前挪一格
            for(const key in this.colConfg) {
              const item = this.colConfg[key]
              if (item.col !== undefined) {
                item.col -= 1
              }
            }
            this.requiredFieldCol = this.requiredFieldCol.map(item => { return item - 1 })
          }
        })
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    // 导入excel的确认提交
    importExcel () {
      if (this.uplaodTemplate) {
        this.initExcel(this.uplaodTemplate)
        this.isViewExcel = false
      } else {
        this.$message.warning('请上传文件！')
      }
    },
    // 提交导入数据
    async submitImport (isAgain = false, payloadUrl) {
      // 数据id更新不需要验证
      if (!this.isUpdateById) {
        const errorNum = await submitVerify({
          luckysheetData: luckysheet.getluckysheetfile(),
          _colConfg: this.colConfg,
          isSecond: this.isSecond,
          requiredFieldCol: this.importModeValue === 1 ? [] : this.requiredFieldCol, // 文件导入更新，必填字段无需判断
          importType: this.importType
        })
        if (errorNum) {
          return this.$message.warning(`填写内容有${errorNum}处错误，请修改后再提交！`)
        }
      }
      // 是否是重新提交的
      this.isViewImport = true
      this.isLoading = true
      this.successNum = 0
      this.errorNum = 0
      this.importCode = 0
      this.errorFileUrl = ''
      this.isSuccess = false
      if (this.isUpdateById) {
        this.toUpdateById()
        return false
      }
      let url
      if (this.btnImportType === 'file') {
        // 文件导入的方式
        url = await this.getFileImportPath()
      } else {
        url = isAgain === true ? payloadUrl : await exportSheetExcel(luckysheet.getluckysheetfile(), this.appName)
      }
      if (url) {
        const query = {
          approvalId: this.approvalId,
          file: '/userfiles/' + url,
          isnotify: this.isNotice, // 0 不告知 1 告知
          ispro: this.importType, // 0 全部 1 个人
          update: this.importModeValue, // 0新增数据 1更新数据 2更新和新增数据
        }
        if (this.btnImportType === 'file') {
          query.file = url
        }
        if (this.importModeValue !== 0) {
          query.condition = this.valueKey == 0 ? ['orders'] : this.valueSearchList
        }
        if (Object.keys(this.unpivot).length > 0) {
          query.unpivot = this.unpivot
        }
        const { code, msg, data } = await apiImportapproval(query)
        this.isLoading = false
        if (code === 0) {
          this.successNum = data.num
          this.errorNum = data.error
          // 校验之后有正确数据就直接提交
          if (data.num > 0) {
            query.file = ''
            await apiImportapproval(query)
          }
          if (data.error === 0) {
            this.isSuccess = true
          } else if (data.error > 0) {
            this.errorFileUrl = data.file
          }
        } else {
          // 提交错误也要把这个文件走完（后台好像也缓存 再走一边才会清除）
          delete query.file
          await apiImportapproval(query)
          this.importCode = code
          this.$message.error(msg)
        }
      }
    },
    // 根据数据id做更新
    async toUpdateById () {
      const sheetData = luckysheet.getluckysheetfile()[0].data.filter(item => { return item.find(iten => { return iten !== null }) })
      const headList = sheetData.splice(0, this.pivotHeadLength)
      const head = headList[0]
      const originalHead = cloneDeep(headList[0]) // 原始第一行的单元格
      headList.forEach((item, index) => {
        if (index > 0) {
          item.forEach((cell, cellIndex) => {
            if (cell.v && head[cellIndex].v) {
              head[cellIndex].v += `.${cell.v}`
            } else if (head[cellIndex].mc) {
              // 获取合并单元格的值
              const mcCell = originalHead[head[cellIndex].mc.c]
              if (mcCell) {
                head[cellIndex].v = `${mcCell.v}.${cell.v}`
              }
            }
          })
        }
      })
      const dataList = []
      // 列转行的配置
      const isCustomHeader = this.importHeaderType === 'custom'
      let rowHeadField, rowHeadValue
      if (isCustomHeader) {
        const { customHeaderInfo } = this.queryConfig
        // 列转行的替换的字段
        rowHeadField = this.property.find(item => { return item.title === customHeaderInfo.rowHeadField })
        // 列转行的值
        rowHeadValue = this.property.find(item => { return item.title === customHeaderInfo.rowHeadValue })
      }
      // 先把表格数据转换成表单数据
      sheetData.forEach(list => {
        const formData = { pivotData: [] }
        list.forEach((item, colIndex) => {
          if (item) {
            const cellConfig = this.getCellConfig('col', item.column || colIndex)
            let key
            let value = item.v
            if (cellConfig) {
              value = cellConfig.type === 'date' ? item.m : item.v
              key = `${cellConfig.title}_${cellConfig.type}`
              formData[key] = value
            } else if (isCustomHeader) {
              // 不存在配置中的就是行转列的字段
              key = head[colIndex] ? head[colIndex].v : ''
              if (key) {
                formData.pivotData.push({ [key]: value })
              }
            }
          }
        })
        const tableData = this.isConditionInsert(formData, this.valueSearchList, true)
        if (tableData) {
          if (formData.pivotData.length > 0) {
            // 处理行转列的数据，转换成正常的一条数据
            formData.pivotData.forEach(item => {
              for (const label in item) {
                const singData = cloneDeep(formData)
                delete singData.pivotData
                // 获取数据id
                singData.approvingId = this.getPivotDataApprovingId(tableData, label)
                let value = item[label]
                if (value && singData.approvingId) {
                  if (rowHeadField) singData[`${rowHeadField.title}_${rowHeadField.type}`] = label
                  if (rowHeadValue) singData[`${rowHeadValue.title}_${rowHeadValue.type}`] = value
                  dataList.push(this.filterUpdateData(singData))
                }
              }
            })

          } else {
            // 不存在行转列一行就是条数据
            formData.approvingId = tableData.approvingId
            dataList.push(this.filterUpdateData(formData))
          }
        }
      })
      if (dataList.length > 0) {
        console.log(dataList.length, '更新的数据')
        const fileName = `appbatchupdate${Date.now()}@${this.approvalId}`
        const url = await stringToArrayBufferUpLoad(dataList, { fileName, isGetFileName: true })
        const query = {
          approvalId: this.approvalId,
          path: url
        }
        const { code } = await updateapprovingbatch(query)
        this.isLoading = false
        this.isSuccess = true
        this.isViewImport = false
        if (code === 0) {
          this.$message.success('数据更新成功')
        }
      }
    },
    getPivotDataApprovingId (tableData, label) {
      let id
      for(const key in tableData) {
        if (key.search(label + '.') !== -1 && key.search('approving_id') !== -1 ) {
          id = tableData[key]
          break
        }
      }
      return id
    },
    filterUpdateData (data) {
      const resData = { approvingId: data.approvingId }
      if (this.queryConfig.updateField) {
        this.queryConfig.updateField.forEach(item => {
          resData[item] = data[item]
        })
      }
      return resData
    },
    async getFileImportPath () {
      const sheetData = luckysheet.getluckysheetfile()[0].data.filter(item => { return item.find(iten => { return iten !== null }) })
      const head = sheetData.splice(0, this.isSecond ? 2 : 1)[0]
      const dataList = []
      sheetData.forEach(list => {
        const formData = {}
        list.forEach((item, colIndex) => {
          if (item) {
            const cellConfig = this.getCellConfig('col', item.column || colIndex)
            let key
            let value = item.v
            if (cellConfig) {
              value = cellConfig.type === 'date' ? item.m : item.v
              key = `${cellConfig.title}_${cellConfig.type}_${cellConfig.name}`
            } else {
              const colName = (head[colIndex] ? head[colIndex].v : '') || '单号'
              key = `${colName}_text_${colName}`
            }
            formData[key] = value
          }
        })
        dataList.push(formData)
      })
      const config = {
        approvalId: this.approvalId,
        isIncludesDetail: this.isSecond,
        msg: '模板生成错误',
        isUpdate: this.importModeValue ? true : false,
        isGetUrl: true
      }
      if (Object.keys(this.unpivot).length > 0) {
        config.unpivot = this.unpivot
      }
      const path = await importData(dataList, config)
      return path
    },
    // 验证完成
    async importData () {
      this.isViewImport = false
    },
    // 重新上传模板
    againHandleSuccess (res) {
      this.submitImport(true, res)
    },
    // 文件上传成功
    handleSuccess (res) {
      this.uplaodTemplate = 'userfiles/' + res
    },
    getFileName (name) {
      if (name) {
        const mps = name.split('/')
        const mp = mps[mps.length - 1]
        const strArr = mp.split('-')
        if (strArr.length > 1) {
          strArr.shift()
        }
        name = strArr.join('-')
      }
      return name
    },
    openExcelImport () {
      this.isViewExcel = true
    },
    // 获取配置
    async getAppInfo () {
      this.countField = {}
      this.fillInData = []
      this.defaultInData = {}
      const obj = { approvalId: this.approvalId }
      if (this.isUpace) {
        let upaceId = localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      const { code, data, msg } = await openapiGetapproval(obj)
      if (code === 0 ) {
        let variableconfig = []
        if (data.variableconfig) {
          variableconfig = await this.setParams({ customData: JSON.parse(data.variableconfig) }, null, true)
        }
        this.appName = data.appname
        this.property = JSON.parse(data.property)
        // 更新选择用到的字段
        let searchData = JSON.parse(data.property)
        searchData = searchData.filter(val => {
          // 只筛选单行、数字、单选、联系人组件
          return val.type === 'text' ||  val.type === 'number' ||  val.type === 'radio' ||  val.type === 'relation-user'
        })
        this.optionSearchList = [];
        for(let i = 0; i < searchData.length; i++){
          this.optionSearchList.push({'value':searchData[i].title + '_' + searchData[i].type,'label':searchData[i].name})
        }
        this.optionSearchList.push(            
          {
            value: 'status',
            label: '状态'
          }
        )
        if (data.baseset) {
          const baseset = JSON.parse(data.baseset)
          if (baseset.importSet) {
            // 应用变量
            if (data.variableconfig) {
              this.customData = JSON.parse(data.variableconfig)
            }
            const importSet = baseset.importSet
            this.isCountField = importSet.isCountField
            // 计算公式
            importSet.countFieldList.forEach(item => {
              if (item.field && item.formula) {
                const obj = {
                  formula: item.formula,
                  value: ''
                }
                const index = this.property.findIndex(iter => { return `${iter.title}_${iter.type}` === item.field })
                if (index !== -1) {
                  obj.name = this.property[index].name
                }
                if (this.countField[item.field] === undefined) this.countField[item.field] = []
                if (this.countField[item.field]) {
                  this.countField[item.field].push(obj)
                }
              }
            })
            this.isShowNotice = importSet.isNotice
            this.noticeText = importSet.noticeText
            this.importModeOptions = importSet.importMode
            this.importModeValue = importSet.importMode[0].value
            this.importTemplate = importSet.importTemplate
            this.functionParms = importSet.functionParms
            this.importTips = this.getText(importSet.importText)
          }
        }
        // 把二级控件的配置也捞出来
        const multistage = ['new-rel-radio', 'details', 'ready-widget']
        // const property = this.property.filter(item => { return !multistage.includes(item.type) })
        const property = [...this.property]
        this.property.filter(item => { return multistage.includes(item.type) }).
        forEach(item => { if (item.list && item.list.length > 0) { property.push(...item.list)  } })
        this.dealProperty(property, variableconfig)
        // 优先文件导入，把外面先上传的文件导进来
        if (this.btnImportType === 'file' || this.uplaodTemplate) {
          this.initExcel(this.uplaodTemplate)
        } else {
          this.initExcel()
        }
      } else {
        this.$message.error(msg)
      }
    },
    // tips的处理
    getText (text) {
      const res = dealText({ 
        text, 
        commonData: this.$store.state.userData, 
        customData: this.customData, 
        functionParms: this.functionParms || []
      })
      return res || text
    },
    // 下载模板
    async downloadTemp () {
      if (this.importTemplate.value === 0) {
        // 获取默认模板
        const url = await this.getDefaultTemp()
        if (url) {
          this.importTemplate.customTemplateUrl = url
        }
      } else {
        // 自定义模板
        if (this.importTemplate.customTemplateUrl === '') {
          // 没有上传模板的情况下
          return this.$message.error('自定义模板未上传，请联系管理员')
        }
      }
      filePreview({ url: this.$apiurl + '/'+ this.importTemplate.customTemplateUrl }, true)
    },
    // 下载错误模板 
    downloadErrorTemp () {
      filePreview({ url: this.$apiurl + this.errorFileUrl }, true)
    },
    // 在线修改错误模板
    editErrorTemp () {
      this.isViewImport = false
      // 清空填入值
      this.fillInData = []
      const path = this.errorFileUrl.slice(1);
      this.initExcel(path)
    },
    // 获取默认模板
    async getDefaultTemp () {
      let url
      let param = {
        approvalId: this.approvalId,
        ispro: this.importType, //个人数据
        update: this.importModeValue
      }
      if (this.unpivot) {
        param.unpivot = this.unpivot
      }
      const { code, data } = await axiosBase(param, '/api/getapprovaltemplate')
      if (code === 0) url = data
      return url
    },
    // 返回旧版
    toBigData () {
      // this.$store.commit('bulkImportMutat', this.importType ? 0 : 1);
      const bulkImportMutat = this.importType === 0 ? true : false
      this.$router.push({ path: '/clientSide/workbench/bigDataTMbulkImport', query: { approvalId: this.approvalId, bulkImportMutat } });
    },
    
    // 处理一下需要联动的控件和默认值的控件
    dealProperty (property, customData = []) {
      this.readonlyCol = []
      this.hideCol = []
      const chooseField = this.customDeskInfo.chooseField || []
      const isChooseUpdate = this.customDeskInfo.isChooseUpdate === 'true' && this.btnImportType === 'table'
      // 处理一下列转行
      if (this.customDeskInfo) {
        const { customHeaderInfo } = this.customDeskInfo
        if (this.customDeskInfo.isAiDrop && this.customDeskInfo.isAiDrop === 'true') {
          this.isAiDrop = true
          this.aiTips = this.getText(this.customDeskInfo.aiTips)
        }
        if (this.importHeaderType === 'custom') {
          const rowHeadField = property.find(item => { return item.title === customHeaderInfo.rowHeadField })
          const rowHeadValue = property.find(item => { return item.title === customHeaderInfo.rowHeadValue })
          if (rowHeadField && rowHeadValue) {
            // 替换的表头要隐藏
            this.hideCol.push(rowHeadField)
            const fields = customHeaderInfo.rowHeadName ? customHeaderInfo.rowHeadName.split(',') : ''
            this.unpivot = { field: rowHeadField.name, fields: fields, value: rowHeadValue.name }
          }
        }
      }
      property.forEach(item => {
        const i = chooseField.findIndex(iten => { return item.title === iten.title })
        if (isChooseUpdate && i === -1) {
          this.hideCol.push(item)
        }
        if (item.bindinf === '' && item.bindfield && item.bindfield[0] === '$' && customData.length > 0) {
          // 绑定应用变量
          const name = item.bindfield.split('$')[1]
          const index = customData.findIndex(item => { return item.name === name })
          if (index !== -1) {
            item.bindinf = customData[index].value
          }
        }
        // 默认值（只设置第一行，如果有传参的值，那就以传参的为准）
        if (item.bindinf || item.bindinf === 0) {
          const key = `${item.title}_${item.type}`
          if (this.defaultInData[key] === undefined) {
            this.defaultInData[key] = item.bindinf
          }
        }
        // 发起隐藏
        if (item.per === 3) {
          if (!isChooseUpdate) {
            this.hideCol.push(item)
          }
        } else if (item.per === 2) {
          // 发起只读
          this.readonlyCol.push(item)
        }
        // 联动和公式
        if (item.dataconfig) {
          const dataconfig = cloneDeep(item.dataconfig)
          // 3是选项联动 1是填充 4是前端公式 7 单选关联
          if (dataconfig.setUpValue === 3 || dataconfig.setUpValue === 1) {
            // 填充联动的控件需要隐藏
            if (dataconfig.setUpValue === 1) {
              // 已经存在的就不用再隐藏了
              const index = this.hideCol.findIndex(iten => { return `${iten.title}_${iten.type}` === `${item.title}_${item.type}` })
              if (index === -1 && !isChooseUpdate) {
                this.hideCol.push(item)
              }
            } else if (dataconfig.setUpValue === 3 ) {
              // 当前选项联动不需要条件
              if (dataconfig.linked && dataconfig.linked.dataOptions) {
                const query = {
                  types: false,
                  approvalId: this.approvalId,
                  dataconfig: dataconfig
                }
                // 从空间进入，需要传空间id
                if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
                  query.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
                }
                getlinkeddatalist(query).then(({ code, data }) => {
                  if (code === 0) {
                    this.dataOptionsData[`${item.title}_${item.type}`] = data || []
                  }
                })
              } else {
                // 选项联动需要条件
                if (dataconfig.linked && Array.isArray(dataconfig.linked.conditional) && dataconfig.linked.conditional.length > 0) {
                  const query = {
                    types: false,
                    approvalId: this.approvalId,
                    dataconfig: dataconfig
                  }
                  // 初始化的时候只处理表单发起人的条件
                  let isGet = false
                  dataconfig.linked.conditional.forEach(link => {
                    if (link.feild === '表单发起人_relation-user') {
                      query[link.feild] = '表单发起人'
                      isGet = true
                    }
                  })
                  // 从空间进入，需要传空间id
                  if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
                    query.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
                  }
                  if (isGet) {
                    getlinkeddatalist(query).then(({ code, data }) => {
                      if (code === 0) {
                        this.dataOptionsData[`${item.title}_${item.type}`] = data || []
                      }
                    })
                  }
                }
              }

            }
            if (dataconfig.linked && dataconfig.linked.conditional && dataconfig.linked.conditional.length > 0) {
              dataconfig.linked.conditional.forEach(iter => {
                if (this.linkage[iter.feild] === undefined) this.linkage[iter.feild] = []
                this.linkage[iter.feild].push(dataconfig)
              })
            }
          } else if (dataconfig.setUpValue === 4) {
            const { formula } = dataconfig
            // type 0 等于 1是求时间差 2 是求明细值 3 是前端公式 4 是函数计算
            if (formula) {
              if (formula.type === 0) {
                formula.setfeild = `${item.title}_${item.type}` // 要设置的对象控件
                if (formula.controls.search('details') !== -1) {
                  // 处理一下明细控件里面的单行
                  formula.controls = formula.controls.split('.')[1]
                }
                if (this.linkage[formula.controls] === undefined) this.linkage[formula.controls] = []
                this.linkage[formula.controls].push(dataconfig)
              } else if (formula.type === 1) {
                formula.setfeild = `${item.title}_${item.type}` // 要设置的对象控件
                if (this.linkage[formula.airTime] === undefined) this.linkage[formula.airTime] = []
                this.linkage[formula.airTime].push(dataconfig)

                if (this.linkage[formula.endTime] === undefined) this.linkage[formula.endTime] = []
                this.linkage[formula.endTime].push(dataconfig)
              } else if (formula.type === 2) {
                formula.setfeild = `${item.title}_${item.type}` // 要设置的对象控件
                if (this.linkage[formula.controls] === undefined) this.linkage[formula.controls] = []
                this.linkage[formula.controls].push(dataconfig)
              } else if (formula.type === 3) {
                // operation 0加 1减  2乘 3除
                // allcontrols 公式前面的字段
                // filterControls 公式后面的字段
                formula.setfeild = `${item.title}_${item.type}` // 要设置的对象控件
                if (this.linkage[formula.allcontrols] === undefined) this.linkage[formula.allcontrols] = []
                this.linkage[formula.allcontrols].push(dataconfig)

                if (this.linkage[formula.filterControls] === undefined) this.linkage[formula.filterControls] = []
                this.linkage[formula.filterControls].push(dataconfig)
              } else if (formula.type === 4) {
                formula.setfeild = `${item.title}_${item.type}` // 要设置的对象控件
                //表达式结构
                let conditionStr = formula.drageFormula.condition;
                // 使用正则表达式匹配大写字母和括号内的内容
                let strFilter = conditionStr.match(/([A-Z]+)\((.*)\)/);
                if (strFilter && strFilter.length >= 3) {
                  const feildNameList = this.getDataWithinBrackets(strFilter[2])
                  feildNameList.forEach(feildName => {
                    const index = property.findIndex(p => feildName === p.name)
                    if (index !== -1) {
                      const key = `${property[index].title}_${property[index].type}`
                      if (this.linkage[key] === undefined) this.linkage[key] = []
                      this.linkage[key].push(dataconfig)
                    }
                  })
                }
              }
            }
          } else if (dataconfig.setUpValue === 7) {
            const { linked } = dataconfig
            if (linked) {
              dataconfig.setfeild = `${item.title}_${item.type}`
              if (Array.isArray(linked.conditional)) {
                linked.conditional.forEach(iter => {
                  if (this.linkage[iter.feild] === undefined) this.linkage[iter.feild] = []
                  this.linkage[iter.feild].push(dataconfig)
                })
              }
            }
          }
          // 组织控件的绑定字段
          if (item.type === 'organization' && item.bindfieldKey) {
            const obj = { setfeild: `${item.title}_${item.type}`, setKey: '部门' }
            if (this.linkage[item.bindfieldKey] === undefined) this.linkage[item.bindfieldKey] = []
            this.linkage[item.bindfieldKey].push(obj)
          }
        }
      })
      if (Object.keys(this.defaultInData).length > 0 && this.fillInData.length === 0) {
        this.fillInData.push(cloneDeep(this.defaultInData))
      }
    },
    // 获取当前单元格的配置
    getCellConfig (pKey, val) {
      let configKey
      for(let key in this.colConfg) {
        const item = this.colConfg[key]
        if (item[pKey] === val) {
          configKey = `${item.title}_${item.type}`
          break
        }
      }
      return this.colConfg[configKey]
    },
    // luckysheet的钩子函数
    // 工作表创建之后
    workbookCreateAfter () {
      // 设置只读列
      this.setReadOnlyCol()

      this.setNumberRow()
      // 设置冻结行
      this.setFrozen()
      const _this = this
      luckysheet.setRangeShow("A1:A1", { 
        success: function() {
          // 设置范围显示后的回调函数
          // 插件本身的loading会延迟500毫秒关闭
          setTimeout(function(){
            _this.isPageLoading = false
          }, 600);
          
        }
      })
      if (this.isBtnCustomInit && this.isBtnCustom) {
        _this.toSetCustomConfig()
        _this.isBtnCustomInit = false
      }
      if (this.isAiDrop) {
        document.querySelector('#luckysheet-sheettable_0').addEventListener('dragover', this.handleDragOver);
      }
    },
    // 单元格点击之前
    async cellMousedownBefore (cell, postion) {
      // 尝试读取剪贴板文本
      // 对获取到的文本进行清洗，只保留文字
      try {
        const text = await navigator.clipboard.readText();
        if (text) {
          this.copyText = text.replace(/<[^>]*>?/gm, '').split('\n')
        }
      } catch (err) {
        this.copyText = ''
      }
      const col = postion.c
      const row = postion.r
      // // 如果单元格有这个属性直接返回 (表头和只读)
      if (cell && (cell.isHead || cell.isReadOnly)) return false
      const cellConfig = this.getCellConfig('col', col)
      if (cellConfig) {
        if (cellConfig.type === 'date') {
          const ct = cell ? cell.ct : null
          let format = cellConfig.match || 'yyyy-MM-dd'
          if (format.search('ww') !== -1) {
            format = format.replace(' ww', '')
          }
          // 存在格式就不要再设置了
          if (!(ct && ct.fa === format)) {
            luckysheet.setCellValue(row, col, {ct: {
              fa: format,
              t: 'd'
            }})
          }
        } 
      }
    },
    // 单元格编辑之前
    async cellEditBefore (range) {
      const col = range[0].column_focus
      const row = range[0].row_focus
      const data = luckysheet.getRangeValuesWithFlatte([{r: row, c: col}])
      let cell = data.length > 0 ? data[0] : null
      // 如果单元格有这个属性直接返回
      if (cell && cell.isHead) return false
      const cellConfig = this.getCellConfig('col', col)
      if (cellConfig) {
        const dataconfig = cloneDeep(cellConfig.dataconfig)
        if (cellConfig.type === 'radio' || cellConfig.type === 'checkbox') {
          let sels = []
          // 有个选项联动的
          if (dataconfig && dataconfig.setUpValue === 3) {
            sels = this.dataOptionsData[`${cellConfig.title}_${cellConfig.type}`] || []
          } else {
            sels = Array.isArray(cellConfig.sels) ? cellConfig.sels.map(item => { return item.value || item}) : JSON.parse(cellConfig.sels)
            sels = sels.map(item => { return typeof item === 'string' ? item.trim() : item })
          }
          if (sels && sels.length > 0) {
            const dataVerification = {
              type: 'dropdown',
              value1: sels.join(','),
              prohibitInput: true
            }
            if (cellConfig.type === 'checkbox') {
              dataVerification.type2 = true // 多选
            }
            luckysheet.setDataVerification(dataVerification)
          }
        } else if (cellConfig.type === 'text') {
          // 单行输入框有个选项联动的
          if (dataconfig && dataconfig.setUpValue === 3) {
            const data = this.dataOptionsData[`${cellConfig.title}_${cellConfig.type}`] || []
            if (data?.length > 0) {
              const dataVerification = {
                type: 'dropdown',
                value1: data.join(',')
              }
              luckysheet.setDataVerification(dataVerification)
            } 
          }
        } else if (cellConfig.type === 'number') {
          // 限制数字格式
          const dataVerification = {
            type: 'number',
            type2: 'gt',
            value1: -99999999999999,
            prohibitInput: true
          }
          luckysheet.setDataVerification(dataVerification)
        } else if (cellConfig.type === 'date') {
          let format = cellConfig.match || 'yyyy-MM-dd'
          if (format.search('ww') !== -1) {
            format = format.replace(' ww', '')
          }
          // 时间格式不要去限制
          if (!['yyyy-MM', 'HH:mm'].includes(format)) {
            // 限制日期格式
            const dataVerification = {
              type: 'date',
              type2: 'nbf',
              value1: '1900/01/01',
              prohibitInput: true
            }
            luckysheet.setDataVerification(dataVerification)
          }
        } else if (cellConfig.type === 'file') {
          this.currentEditCell = { col, row }
          const obj = {
            config: cellConfig
          }
          if (cell && cell.v) {
            const fileList = cell.v.split(',').map(item => {
              item.replace('/userfiles/')
            })
            fileList
          }
          setTimeout(() => {
            luckysheet.exitEditMode()
            this.$refs.fileUploadDiaRef.open(obj)
          }, 10)
        }
      }
    },
    // 单元格更新之前
    cellUpdateBefore (r, c, value) {
      let isHead = r < (this.isSecond ? 2 : 1)
      if (this.isUpdateById) {
        isHead = this.pivotHeadLength
      }
      if (isHead && value !== '单号') return false
      // 要去设置一下单元格文本格式
      this.setTextCollFormat(r, c)
      // 存在默认值才去判断要不要填
      if (Object.keys(this.defaultInData).length > 0) {
        const col = luckysheet.getSheet().visibledatacolumn.length - 1
        let data = luckysheet.getRangeArray('oneDimensional', { range: { row: [r, r], column: [0, col] } }) || []
        if (data && data[c]) {
          data.splice(c, 1)
        }
        this.isInsertData = !(data.find(item => { return item || item === 0 })) && typeof value !== 'object'
      }
    },
    // 单元格值更新之后
    async cellUpdated (r, c, oldValue, newValue) {
      console.log('值改变', newValue)
      const cellConfig = this.getCellConfig('col', c)
      // console.log('单元格配置', cellConfig)
      if (!cellConfig || (newValue && newValue.v === undefined)) return
      // 错误的单元格重新填值后去除颜色提示
      if (newValue) {
        if (['#cc0000', '#FF0000', '#0066CC'].includes(newValue.bg) && newValue.v.search('不存在下拉选项中') === -1 ) {
          luckysheet.setCellFormat(r, c, 'bg', '#FFFFFF')
        }
      }
      let feild
      if (cellConfig.ftype) {
        // 明细的控件
        feild = `${cellConfig.ftitle}_${cellConfig.ftype}.${cellConfig.title}_${cellConfig.type}`
      } else {
        feild = `${cellConfig.title}_${cellConfig.type}`
      }
      // 当前行无数据加存在默认值再去填写默认值
      if (this.isInsertData && Object.keys(this.defaultInData).length > 0) {
        this.dealDefaultInData({ row: r, item: cellConfig })
      }
      this.isInsertData = false
      const linkageConfig = this.linkage[feild] // 这个控件值改变触发的联动
      // 表单联动
      if (linkageConfig && linkageConfig.length > 0) {
        for (let index = 0; index < linkageConfig.length; index++) {
          const item = linkageConfig[index]
          // 选项和填充联动
          if (item.setUpValue === 1 || item.setUpValue === 3) {
            const query = {
              types: false,
              approvalId: this.approvalId,
              dataconfig: item
            }
            if (item.linked && Array.isArray(item.linked.conditional)) {
              for (const iten of item.linked.conditional) {
                let _feild = iten.feild
                if (iten.feild && iten.feild.search('details') !== -1) {
                  // 明细内的联动
                  _feild = iten.feild.split('.')[1]
                }
                let value = luckysheet.getCellValue(r, this.colConfg[_feild].col)
                value = await this.getUserValue(value, this.colConfg[_feild].type)
                query[iten.feild] = value || ''
              }
            }
            if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
              query.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
            }
            const { code, data } = await getlinkeddatalist(query)
            if (code === 0) {
              const resultdata = item.linked.resultdata
              if (item.setUpValue === 3) {
                // 选项联动
                const dataVerification = {
                  type: 'dropdown',
                  value1: data.join(','),
                  prohibitInput: true
                }
                resultdata.forEach(iter => {
                  let setFeildConfig // 要设置对象的配置
                  if (iter.setfeild.search('details') !== -1) {
                    // 明细
                    const setfeild = iter.setfeild.split('.')[1]
                    setFeildConfig = this.colConfg[setfeild]
                  } else {
                    setFeildConfig = this.colConfg[iter.setfeild]
                  }
                  if (setFeildConfig) {
                    // 清空验证和选中值
                    luckysheet.deleteDataVerification({
                      range: { row: [r,r], column: [setFeildConfig.col, setFeildConfig.col] },
                      success: () => {
                        luckysheet.setCellValue(r, setFeildConfig.col, '')
                      }
                    })

                    if (setFeildConfig.type === 'checkbox') {
                      dataVerification.type2 = true // 多选
                    }
                    // 下拉选项不能为空
                    if (dataVerification.value1) {
                      luckysheet.setDataVerification(dataVerification, {range: { row: [r,r], column: [setFeildConfig.col, setFeildConfig.col] }})
                    }
                  }
                })
              } else if (item.setUpValue === 1) {
                // 填充联动
                resultdata.forEach(iter => {
                  let setFeildConfig // 要设置对象的配置 
                  let setfeild
                  if (iter.setfeild.search('details') !== -1) {
                    // 明细
                    setfeild = iter.setfeild.split('.')[1]
                    setFeildConfig = this.colConfg[setfeild]
                  } else {
                    setFeildConfig = this.colConfg[iter.setfeild]
                  }
                  if (`${setFeildConfig.title}_${setFeildConfig.type}` === (setfeild || iter.setfeild)) {
                    let value = data[0] !== undefined ? data[0] : ''
                    if (setFeildConfig.type === 'relation-user' && Array.isArray(value) && value.length > 0) {
                      value = value[0].realname
                    }
                    luckysheet.setCellValue(r, setFeildConfig.col, value)
                  }
                })
              }
            }
          } else if (item.setUpValue === 4) {
            // 前端公式
            const { formula } = item
            let setfeild
            if (formula.setfeild && formula.setfeild.search('details') !== -1) {
              // 明细
              setfeild = formula.setfeild.split('.')[1]
            } else {
              setfeild = formula.setfeild
            }
            const setFeildConfig = this.colConfg[setfeild] // 要设置对象的配置
            if (setFeildConfig) {
              // const setFeildKey = `${setFeildConfig.title}_${setFeildConfig.type}`
              if (formula.type === 0) {
                // 前端公式的等于
                luckysheet.setCellValue(r, setFeildConfig.col, newValue.v)
              } else if (formula.type === 1) {
                // 前端公式的求时间差
                let airTime, endTime
                if (this.colConfg[formula.airTime]) {
                  airTime = luckysheet.getCellValue(r, this.colConfg[formula.airTime].col)
                }
                if (this.colConfg[formula.endTime]) {
                  endTime = luckysheet.getCellValue(r, this.colConfg[formula.endTime].col)
                }
                if (airTime && endTime) {
                  const value = onTimeDifference(airTime, endTime, formula.calculation, formula.digital)
                  luckysheet.setCellValue(r, setFeildConfig.col, value)
                }
              } else if (formula.type === 2) {
                // 前端公式的求明细值
                // calculation 计算方式 0 求和 1 求平均值 2求最大值 3求最小值
                // digital 保留小数点 0 取整（四舍五入） 1 取整（舍弃小数点） 2 保留小数点后1位 3 保留小数点后2位
                const setFeildRowRange = this.inputRow.find(item => { return r >= item.startRow && r <= item.endRow })
                if (setFeildRowRange && setFeildRowRange.startRow) {
                  const startRow = setFeildRowRange.startRow
                  const endRow = setFeildRowRange.endRow
                  const data = luckysheet.getRangeArray('oneDimensional', { range: {row:[startRow, endRow],column:[c, c] }})
                  const numList = data.filter(iter => { return iter && !isNaN(Number(iter)) })
                  let resValue = 0
                  switch (formula.calculation) {
                    case 0: {
                      resValue = numList.reduce((a, b) => a + Number(b), 0);
                      break
                    }
                    case 1: {
                      const sum = numList.reduce((a, b) => a + Number(b), 0);
                      resValue = sum / numList.length 
                      break
                    }
                    case 2: {
                      resValue = Math.max(...numList);
                      break
                    }
                    case 3: {
                      resValue = Math.min(...numList);
                      break
                    }
                  }
                  resValue = this.setDigital(resValue, formula.digital)
                  luckysheet.setCellValue(startRow, setFeildConfig.col, resValue)
                }
              } else if (formula.type === 3) {
                // 前端公式的四则运算
                const number1Conifg = this.colConfg[formula.allcontrols]
                const number2Conifg = this.colConfg[formula.filterControls]
                const number1 = Number(luckysheet.getCellValue(r, number1Conifg.col) || 0)
                const number2 = Number(luckysheet.getCellValue(r, number2Conifg.col) || 0)
                let resData = 0
                // 前端公式的四则运算
                switch(formula.operation){
                  case 0:
                    // 加
                    resData = number1 + number2
                    break;
                  case 1:
                    // 减
                    resData = number1 - number2
                    break;
                  case 2:
                    // 乘
                    resData = number1 * number2
                    break;
                  case 3:
                    // 除
                    resData = number2 ? number1 / number2 : 0
                    break;
                }
                luckysheet.setCellValue(r, setFeildConfig.col, resData)
              } else if (formula.type === 4) {
                // 前端公式的函数计算
                //表达式结构
                let conditionStr = formula.drageFormula.condition;
                // 使用正则表达式匹配大写字母和括号内的内容
                let strFilter = conditionStr.match(/([A-Z]+)\((.*)\)/);
                if (strFilter && strFilter.length >= 3) {
                  const mathFun = strFilter[1]
                  const nameVal = strFilter[2]
                  const feildNameList = this.getDataWithinBrackets(strFilter[2])
                  const formdata = {}
                  feildNameList.forEach(feildName => {
                    const cellConfig = this.getCellConfig('name', feildName)
                    if (cellConfig) {
                      const field = `${cellConfig.title}_${cellConfig.type}`
                      const value = luckysheet.getCellValue(r, cellConfig.col)
                      formdata[field] = cellConfig.type === 'number' ?  Number(value || 0) : value
                    }
                  })
                  let val = this.dragResule(nameVal,formdata)
                  let resultVal = this.mathFunRun(val, mathFun)
                  if (resultVal !== undefined) {
                    luckysheet.setCellValue(r, setFeildConfig.col, resultVal)
                  }
                } else {
                  console.log("未找到匹配的内容。");
                }
              }
            }
          } else if (item.setUpValue === 7) {
            // 单选关联
            const relRadio = this.property.find(iter => { return `${iter.title}_${iter.type}` === item.setfeild })
            if (relRadio) {
              // 要设置的控件
              const setFeildList = relRadio.list.map(iter => {
                return `${iter.title}_${iter.type}` 
              })
              const query = {
                relWidDataLook: relRadio.relWidDataLook ? relRadio.relWidDataLook : 1,
                approvalId: relRadio.relFormId,
                curpage: 1,
                pagesize: 1,
                datahided: relRadio.datahided,
                appid: this.approvalId,
              }
              if(relRadio.dataconfig){
                query.dataconfig = relRadio.dataconfig
                if (item.linked && Array.isArray(item.linked.conditional)) {
                  query.condition = {}
                  item.linked.conditional.forEach(iter => {
                    query.condition[iter.feild] = newValue.v
                  })
                }
              }
              // 从空间进入，需要传空间id
              if(this.isSpace){
                let spaceId = localStorage.getItem('spaceid');
                query.spaceid = spaceId;
              }
              else if (this.isUpace) {
                let upaceId = localStorage.getItem('upaceid')
                query.upaceid = upaceId
              }
              const { code, data } = await apiGetreportdatalist(query)
              if (code === 0 && data.length > 0) {
                setFeildList.forEach(key => {
                  const setCellConfig = this.colConfg[key]
                  let value = data[0][setCellConfig.titleId]
                  if (setCellConfig.type === 'relation-user' && Array.isArray(value) && value.length > 0) {
                    value = value[0].realname
                  }
                  luckysheet.setCellValue(r, setCellConfig.col, value)
                })
              }
            }
          }
          // 字段绑定了联系人
          if (cellConfig.type === 'relation-user' && item.setKey) {
            const query = { curpage: 0, pagesize: 0, name: newValue.v }
            const { code, data } = await getopenuserlist(query)
            if (code === 0 && data.length > 0) {
              const user = data[0]
              let setFeildConfig = this.colConfg[item.setfeild] // 要设置对象的配置 
              luckysheet.setCellValue(r, setFeildConfig.col, user[item.setKey] || '')
            }
          }
        }
      }
      // 字段计算
      this.feildCount(cellConfig)
      if (newValue !== undefined && cellConfig.required === 'required') {
        this.setNumberRow()
      }
    },
    async getUserValue (value, type) {
      let resValue = value
      const obs = {
        'relation-user': {
          idKey: 'userId',
          saveKey: 'userSaveData'
        },
        organization: {
          idKey: 'organizationId',
          saveKey: 'orgSaveData'
        },
        roule: {
          idKey: 'roleId',
          saveKey: 'roleSaveData'
        }
      }
      if (['relation-user', 'organization', 'roule'].includes(type)) {
        resValue = []
        const idKey = obs[type].idKey
        const saveKey = obs[type].saveKey
        const name = value.split(',').filter(item => {
          let isFilter = true
          if (this.extractWithStringMethods(item)) {
            isFilter = false
            const obj = {
              name: item.split('(')[0],
              [idKey]: this.extractWithStringMethods(item),
            }
            this[saveKey][item.split('(')[0]] = obj // 搜索过的存起来 避免重复查询
            resValue.push(obj)
          } else if (this[saveKey][item]){
            resValue.push(this[saveKey][item])
          }
          return isFilter
        }).join()
        let fn = type === 'relation-user' ? getopenuserlist : (type === 'organization' ? getopenorganizationlist : getopenrolelist)
        const query = {
          curpage: 0,
          pagesize: 0,
          name
        }
        if (query.name) {
          const { code, data } = await fn(query)
          if (code === 0) {
            resValue = data.map(item => {
              return { name: item.realname || item.name, [idKey]: item[idKey] }
            })
          }
        }
      }
      return resValue
    },
    extractWithStringMethods(text) {
      // 1. 判断是否存在括号
      if (text.includes('(') && text.includes(')')) {
        // 2. 找到括号的起始和结束位置
        const startIndex = text.indexOf('(');
        const endIndex = text.indexOf(')');

        // 3. 确保括号顺序正确且右括号在左括号之后
        if (startIndex !== -1 && endIndex !== -1 && endIndex > startIndex) {
          // 4. 提取括号内的内容（起始索引+1，结束索引不包含）
          const content = text.substring(startIndex + 1, endIndex);
          return content;
        }
      }
      return null;
    },
    // 粘贴前
    rangePasteBefore (range) {
      // 要去设置一下单元格文本格式
      if (range[0] && range[0].column && range[0].row) {
        const { column, row } = range[0]
        // 对获取到的文本进行清洗，只保留文字
        if (this.copyText) {
          let copyTextLen = this.copyText.length
          if (this.copyText[copyTextLen - 1] === '') {
            copyTextLen--
          }
          const rowLen = row[1] - row[0] + 1
          // 获取真实的复制行数
          row[1] = copyTextLen > rowLen ? row[0] + copyTextLen : row[1]
        }
        // 默认值的处理
        if (Object.keys(this.defaultInData).length > 0) {
          // 粘贴前的表格数据
          const sheetData = cloneDeep(luckysheet.getSheet().data)
          setTimeout(async () => {
            // 粘贴区域的值
            const data = luckysheet.getRangeArray('oneDimensional', { range: { row, column } })
            let dataIndex = 0
            // 循环行
            for (let rowIndex = cloneDeep(row[0]); rowIndex <= row[1]; rowIndex++) {
              // 循环列
              for (let col = column[0]; col <= column[1]; col++) {
                // 当前行无数据加存在默认值再去填写默认值
                const isSetDefault = !(sheetData[rowIndex].find((item, itemIndex) => { return !column.includes(itemIndex) && (item || item === 0) }))

                if (isSetDefault && data[dataIndex]) {
                  const cellConfig = this.getCellConfig('col', col)
                  this.dealDefaultInData({ row: rowIndex, item: cellConfig })
                }
                dataIndex++
              }
            }
          }, 100)
        }
      }
    },
    // 粘贴后
    rangePasteAfter (range) {
      if (range[0] && range[0].column && range[0].row) {
        const { column, row } = range[0]
        const data = luckysheet.getRangeArray('oneDimensional', { range: { row, column } })
        let dataIndex = 0
        const dataVerifObj = {}
        // 获取单选框或者多选框的选项验证
        for (let col = column[0]; col <= column[1]; col++) {
          const cellConfig = this.getCellConfig('col', col)
          if (cellConfig) {
            const dataconfig = cloneDeep(cellConfig.dataconfig)
            if (cellConfig.type === 'radio' || cellConfig.type === 'checkbox') {
              let sels = []
              // 有个选项联动的
              if (dataconfig && dataconfig.setUpValue === 3) {
                sels = this.dataOptionsData[`${cellConfig.title}_${cellConfig.type}`] || []
              } else {
                sels = Array.isArray(cellConfig.sels) ? cellConfig.sels.map(item => { return item.value || item}) : JSON.parse(cellConfig.sels)
                sels = sels.map(item => { return typeof item === 'string' ? item.trim() : item })
              }
              if (sels && sels.length > 0) {
                dataVerifObj[col] = sels
              }
            }
          }
        }
        for (let rowIndex = row[0]; rowIndex <= row[1]; rowIndex++) {
          for (let col = column[0]; col <= column[1]; col++) {
            const value =  data[dataIndex]
            // 选项验证
            if (dataVerifObj[col] && (value || value === 0)) {
              const strValue = typeof value === 'number' ? value.toString() : value
              strValue.split(',').forEach(val => {
                if (!dataVerifObj[col].includes(val)) {
                  luckysheet.setCellValue(rowIndex, col, { v: val + '不存在下拉选项中', bg: '#FF0000' });
                }
              })
            }
            this.cellUpdated(rowIndex, col, null, { v: value })
            dataIndex++
          }
        }
      }
    },
    // 设置单元格的文本格式
    setTextCollFormat (row, col) {
      const data = luckysheet.getRangeValuesWithFlatte([{r: row, c: col}])
      const cellValue = data.length > 0 ? data[0] : null
      if (cellValue === null || (cellValue && cellValue.ct && cellValue.ct.fa === 'General' && cellValue.ct.t === 'n')) {
        const cellConfig = this.getCellConfig('col', col)
        if (!cellConfig || ['text', 'number'].includes(cellConfig.type)) {
          // 把单号和文本、数字的格式设置为纯文本
          const ct = {
            fa: '@',
            t: 's'
          }
          luckysheet.setCellFormat(row, col, 'ct', ct)
        }
      }
    },
    // 字段计算
    feildCount (cellConfig) {
      // 字段计算
      const feild = `${cellConfig.title}_${cellConfig.type}`
      const countFieldConfig = this.countField[feild]
      if (countFieldConfig) {
        const col = cellConfig.col
        const row = luckysheet.getSheet().visibledatarow.length - 1
        const data = luckysheet.getRangeArray('oneDimensional', {range: {row:[this.isSecond ? 2 : 1, row],column:[col, col]}})
        const numList = data.filter(iter => { return iter && !isNaN(Number(iter)) })
        countFieldConfig.forEach(item => {
          if (item.formula === 'sum') {
            const sum = numList.reduce((a, b) => a + Number(b), 0);
            item.value = sum
          } else if (item.formula === 'avg') {
            const sum = numList.reduce((a, b) => a + Number(b), 0);
            const avg = sum / numList.length 
            item.value = avg
          }
        })
      }
      this.$forceUpdate()
    },
    setNumberRow () {
      // 最后一行
      const lastRow = luckysheet.getSheet().visibledatarow.length - 1 
      // 筛选后的每行的数据
      let dataList = []
      this.requiredFieldCol.forEach(col => {
        const data = luckysheet.getRangeArray('oneDimensional', { range: {row:[0, lastRow],column:[col, col] }})
        if (dataList.length === 0) {
          dataList = data
        } else {
          data.forEach((item, index) => {
            if (item !== null && dataList[index] === null) {
              dataList[index] = item
            }
          })
        }
      })
      // 获取每条数据之间的间隔行
      const inputArr = []
      dataList.forEach((item, index) => {
        const inputArrLength = inputArr.length
        if (item !== null) {
          if (inputArrLength === 0) {
            const obj = { startRow: index}
            inputArr.push(obj)
          } else if(inputArr[inputArrLength - 1].endRow === undefined) {
            inputArr[inputArrLength - 1].endRow = index - 1
            const obj = { startRow: index}
            inputArr.push(obj)
          } 
        } else if (index === dataList.length -1) {
          inputArr[inputArrLength - 1].endRow = index
        }
      })
      this.inputRow = inputArr
    },
    // 保留小数点
    setDigital (val, type) {
      // type 保留小数点 0 取整（四舍五入） 1 取整（舍弃小数点） 2 保留小数点后1位 3 保留小数点后2位
      switch (type) {
        case 0: {
          val = Math.round(val)
          break
        }
        case 1: {
          val = Math.floor(val)
          break
        }
        case 2: {
          val = parseFloat(val.toFixed(1))
          break
        }
        case 3: {
          val = parseFloat(val.toFixed(2))
          break
        }
      }
      return val
    },
    // 设置冻结行
    setFrozen () {
      if (this.isUpdateById) {
        luckysheet.setHorizontalFrozen(true, { range: `A${this.pivotHeadLength}` })
      } else if (this.isSecond) {
        luckysheet.setHorizontalFrozen(true, { range: 'A2' })
      } else {
        luckysheet.setHorizontalFrozen(false)
      }
    },
    // 设置只读列
    setReadOnlyCol () {
      const row = luckysheet.getSheet().visibledatarow.length - 1
      for(const item of this.readonlyCol) {
        if (item.col !== undefined) {
          luckysheet.setRangeFormat('bg', '#F0F2F5', { range: { row:[0, row], column:[item.col, item.col]} })
          luckysheet.setRangeFormat('isReadOnly', true, { range: { row:[0, row], column:[item.col, item.col]} })
        }
      }
    }
  },
  mounted () {
    this.initConfig()
    if (this.approvalId) {
      this.getAppInfo()
    }
    // 是否有传参
    const TMbulkImportObs = localStorage.getItem('TMbulkImportObs')
    // 是否有变量覆盖
    const defaultDataObs = localStorage.getItem('defaultDataObs')
    // 是否有传入全部数据
    const importAllData = localStorage.getItem('importAllData')
    this.fillInData = []
    this.defaultInData = []
    if (TMbulkImportObs) {
      this.fillInData = JSON.parse(TMbulkImportObs)
      localStorage.removeItem('TMbulkImportObs')
    }
    if (defaultDataObs) {
      this.defaultInData = JSON.parse(defaultDataObs)
      localStorage.removeItem('defaultDataObs')
    } 
    if (importAllData) {
      // 用于数据id更新做匹配的
      this.importAllData = JSON.parse(importAllData)
      if (Array.isArray(this.importAllData) && this.importAllData[0]) {
        let pivotDataItem
        for (const key in this.importAllData[0]) {
          if (key.search('.approving_id') !== -1) {
            pivotDataItem = key
            break;
          }
        }
        if (pivotDataItem) {
          this.pivotHeadLength = pivotDataItem.split('.').length - 2
        }
      }
      localStorage.removeItem('defaultDataObs')
    }
    // ai文件拖入导入
    if (this.isAiDrop) {
      document.addEventListener('dragover', this.handleDragOver);
    }
  },
  unmounted () {
    document.removeEventListener('dragover', this.handleDragOver);
    if (document.querySelector('#luckysheet-sheettable_0')) {
      document.querySelector('#luckysheet-sheettable_0').removeEventListener('dragover', this.handleDragOver);
    }
    luckysheet.destroy()
  }
}
</script>

<style lang="scss" scoped>
  .bulk-import {
    width: 100%;
    min-height: 70vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    &-head, &-footer {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding: 0 30px;
      align-items: center;
      background-color: #fff;
    }
    &-head {
      border-bottom: 1px solid #E8E8E8;
    }
    &-footer {
      border-top: 1px solid #E8E8E8;
      &-left {
        display: inline-flex;
        flex: 1;
        .option-title {
          margin-right: 10px;

        }
        .notice {
          margin-left: 10px;
        }
      }
      &-right {
        span {
          padding: 0 5px;
        }
        .field-line {
          border-right: 1px solid #333;
        }
      }
    }
    &-table {
      flex: 1;
      // height: calc( 100% - 120px );
    }
    .mask-box {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: #fff;
      z-index: 9001;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
      }
      &-text {
        font-size: 12px;
        // position: relative;
        // top: -60px;
      }
    }
  }
  .excel-import {
    color: #333333;
    padding: 10px 0;
    .upload-content {
      padding: 14px 0;
      border-bottom: 1px solid #E9E9E9;
      display: flex;
      justify-content: space-between;
      &-left, &-right {
        color: #6D7D8F;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px solid #E4ECEC;
        border-radius: 4px;
        background-color: #F8F9FD;
        .download-btn, .download-btn-title {
          width: calc(100% - 40px);
        }
        .download-btn {
          height: 130px;
          margin-top: 10px;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          span {
            margin-top: 10px;
          }
        }
      }
      &-left {
        width: 160px;
        .download-btn {
          color: #4E86FF;
          background-color: rgba(240, 244, 255);
          border: 1px solid #E4ECEC;
        }
      }
      &-right {
        width: 500px;
        .download-btn {
          width: 450px;
          background-color: #FFF;
          border: 1px dashed #4E86FF;
          .top {
            flex: 1;
            display: flex;
            align-items: center;
            i {
              font-size: 28px;
            }
          }
          .bottom {
            width: 100%;
            height: 50px;
            border-top: 1px solid #E9E9E9;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>span {
              margin: 0 20px;
            }
          }
        }
      }
    }
    &-tips {
      .excel-import-tips-title {
        padding: 10px 0;
      }
    }
  }
  .import-verify {
    padding: 20px 0;
    .succes-tips {
      color: #4E86FF;
    }
    .error-tips {
      margin: 10px 0;
      color: #ff2b45;
    }
    .edit-tips {
      padding: 0 20px;
      color: #666666;
      p {
        line-height: 28px;
      }
    }
  }
</style>